import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { IDocumentAssemblerGenerationResponse } from './generation-types';
import { GENERATIONS_URL } from './helpers';

export const useDocumentAssemblerGeneration = (generationId: string | null) => {
  const { data, error, isLoading, mutate } =
    useSWR<IDocumentAssemblerGenerationResponse>(
      generationId ? `${GENERATIONS_URL}/${generationId}` : null,
      SWRFetcher({ method: 'GET' })
    );

  return { generation: data?.generation, error, isLoading, mutate };
};
